import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ModalContainerModule from "../../../modules/modalContainer";
import { ResponsiveRow } from "../../../../constants/layout.constants";
import {
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
} from "@mui/material";
import { orgBankAccounts } from "../../../../services/bank.service";
import { adjustForTimezone, isNullUndefined } from "../../../../util/util";
import { issueWarnMessage } from "../../../../actions/message";
import { savePettyCashEntry } from "../../../../services/pettyCash.service";
import { ledgerAccForBank } from "../../../../services/list.service";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const PettyCashTopup = (props) => {
  const [transaction, setTransaction] = useState();
  const [orgBankAccountsList, setOrgBankAccountsList] = useState([]);
  const [ledgerAccountsList, setLedgerAccountsList] = useState([]);
  const [applyToSubscription, setApplyToSubscription] = useState(false);

  const user = useSelector((state) => state.auth.user);

  const onSelectDate = (date) => {
    setTransaction({
      ...transaction,
      date: date,
    });
  };

  const handleClose = () => {
    props.close(false);
    setTransaction({
      description: null,
      facilityId: user.proxyFacility,
      bankAccountId: null,
      ledgerAccountId: null,
      amount: null,
    });
    setApplyToSubscription(false);
  };
  const saveTopup = () => {
    if (isNullUndefined(transaction?.date)) {
      issueWarnMessage("Date is required");
      return;
    }
    if (isNullUndefined(transaction.amount)) {
      issueWarnMessage("Amount is required");
      return;
    }
    if (isNullUndefined(transaction.bankAccountId)) {
      issueWarnMessage("A Source Bank Account is required");
      return;
    }
    if (isNullUndefined(transaction.ledgerAccountId)) {
      issueWarnMessage("A Ledger Account is required");
      return;
    }
    if (isNullUndefined(transaction.description)) {
      issueWarnMessage("Memo is required");
      return;
    }

    transaction.applyToSubscription = applyToSubscription;
    savePettyCashEntry(transaction)
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        props.close(false);
        handleClose();
      });
  };

  useEffect(() => {
    setTransaction({
      description: null,
      facilityId: user.proxyFacility,
      bankAccountId: null,
      ledgerAccountId: null,
      amount: null,
    });
    orgBankAccounts()
      .then((data) => setOrgBankAccountsList(data))
      .catch((error) => {
        console.error("error", error);
      });
  }, [user.proxyFacility]);

  useEffect(() => {
    if (transaction?.bankAccountId) {
      ledgerAccForBank(transaction.bankAccountId)
        .then((data) => setLedgerAccountsList(data))
        .catch((error) => {
          console.error("error", error);
        });
    }
  }, [transaction?.bankAccountId]);

  return (
    <ModalContainerModule
      size="sm"
      accept={saveTopup}
      cancel={handleClose}
      openModal={props.open}
      modalTitle="Top-up Petty Cash"
      acceptButtonText="Save"
    >
      <ResponsiveRow container sx={{ height: "auto" }}>
        <FormControl
          sx={{
            width: { xs: "100%", lg: "50%" },
            marginBottom: "20px",
          }}
          required={true}
        >
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="en-gb"
          >
            <DatePicker
              id={props.componentID}
              label={props.labelText ? props.labelText : "Date"}
              openTo="day"
              sx={{ width: { xs: "100%", lg: "90%" } }}
              InputLabelProps={{
                shrink: true,
              }}
              inputFormat="dd/MMM/yyyy"
              disableFuture={true}
              slotProps={{ textField: { required: true }}}
              onChange={(new_value) => onSelectDate(adjustForTimezone(new Date(new_value)))}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl
          item
          sx={{
            width: { xs: "100%", lg: "50%" },
            marginBottom: "10px",
          }}
          required={true}
        >
          {/* required */}
          <InputLabel>Amount</InputLabel>
          <OutlinedInput
            sx={{ width: "90%" }}
            id={"amount"}
            type="number"
            label="Amount"
            value={transaction?.amount ?? ""}
            onChange={(event) =>
              setTransaction({
                ...transaction,
                amount: event.target.value,
              })
            }
          />
        </FormControl>
      </ResponsiveRow>

      <ResponsiveRow container sx={{ height: "auto" }}>
        <FormControl
          item
          sx={{
            width: { xs: "100%", lg: "50%" },
          }}
          required={true}
        >
          {/* required */}
          <InputLabel>Source Bank Account</InputLabel>
          <Select
            sx={{ width: { xs: "100%", md: "90%" } }}
            id={"bankAccountId"}
            label="Source Bank Account"
            value={transaction?.bankAccountId ?? ""}
            isrequired={true}
            onChange={(event) =>
              setTransaction({
                ...transaction,
                bankAccountId: event.target.value,
              })
            }
          >
            {orgBankAccountsList.length > 0 ? (
              orgBankAccountsList.map(function (account, i) {
                return (
                  <MenuItem key={account.value} value={account.value}>
                    {account.label}
                  </MenuItem>
                );
              }, this)
            ) : (
              <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
            )}
          </Select>
        </FormControl>
        {transaction?.bankAccountId && (
          <FormControl
            item
            sx={{
              width: { xs: "100%", lg: "50%" },
              marginBottom: "10px",
            }}
            required={true}
          >
            {/* required */}
            <InputLabel>Ledger Account</InputLabel>
            <Select
              label="Ledger Account"
              sx={{ width: { xs: "100%", md: "90%" } }}
              id={"ledgerAccountId"}
              value={transaction?.ledgerAccountId ?? ""}
              onChange={(event) =>
                setTransaction({
                  ...transaction,
                  ledgerAccountId: event.target.value,
                })
              }
            >
              {ledgerAccountsList.length > 0 ? (
                ledgerAccountsList.map(function (account, i) {
                  return (
                    <MenuItem key={account.value} value={account.value}>
                      {account.label}
                    </MenuItem>
                  );
                }, this)
              ) : (
                <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
              )}
            </Select>
          </FormControl>
        )}
      </ResponsiveRow>
      <ResponsiveRow container sx={{ height: "auto" }}>
        <FormControl
          item
          sx={{
            width: { xs: "100%", lg: "100%" },
            marginBottom: "10px",
          }}
          required={true}
        >
          {/* required */}
          <InputLabel>Memo</InputLabel>
          <OutlinedInput
            label="Memo"
            id="description"
            type="text"
            sx={{
              width: { xs: "100%", md: "90%" },
            }}
            onChange={(event) => {
              setTransaction({
                ...transaction,
                description: event.target.value,
              });
            }}
            value={transaction?.description ?? ""}
            isrequired={true}
            multiline
            rows={4}
          />
        </FormControl>
      </ResponsiveRow>
      <ResponsiveRow container sx={{ height: "auto" }}>
        <FormControl item sx={{ width: "100%", margin: "auto 10px 10px 10px" }}>
          <FormControlLabel
            control={
              <Switch
                checked={applyToSubscription}
                onChange={(event) =>
                  setApplyToSubscription(event.target.checked)
                }
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label="Apply to Subscription"
          />
        </FormControl>
      </ResponsiveRow>
    </ModalContainerModule>
  );
};

export default PettyCashTopup;
